import { render, staticRenderFns } from "./signals.vue?vue&type=template&id=525b9df5&"
import script from "./signals.vue?vue&type=script&lang=js&"
export * from "./signals.vue?vue&type=script&lang=js&"
import style0 from "./signals.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports